import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { toast, ToastContainer  } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastHeader } from "react-bootstrap";
// import "./WINHbA1cModal.css";

Modal.setAppElement("#root");

const WINHbA1cModal = ({ isOpen, onClose, reloadBonusGoals }) => {
  const navigate = useNavigate();
  const [testResult, setTestResult] = useState("");
  const [testDate, setTestDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [testResultError, setTestResultError] = useState("");
  const [testDateError, setTestDateError] = useState("");
  const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
  const deviceType = "PatientPortal";
  const email = useSelector((state) => state.email.email); // Getting the email from Redux store
  const contract = useSelector((state) => state.userData);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!isOpen) {
      setError(null); // Clear errors when modal is closed
      setTestResult("");
      setTestDate(null);
      setTestResultError("");
      setTestDateError("");
    }
  }, [isOpen]);

  const validateFields = () => {
    let isValid = true;

    if (!testResult.trim()) {
      setTestResultError("Please enter a valid test result. Only numeric values are allowed.");
      isValid = false;
    } else {
      setTestResultError("");
    }

    if (!testDate) {
      setTestDateError("Please select a test date.");
      isValid = false;
    } else {
      setTestDateError("");
    }

    return isValid;
  };


  const handleSaveHbA1cDetails = async () => {
    if (!validateFields()) {
      return; // Prevent API call if validation fails
    }

    setLoading(true);
    setError(null);
    
    try {
      const response = await axios.post(
        Endpoints.SaveHbA1cDetails,
       `_Params=${encodeURIComponent(
            JSON.stringify({
              MemberID: contract.userData.MemberID,
              Contract: contract.userData.ContractIdentified,
              testresult: testResult,
              testdate: testDate, // MM/DD/YYYY format
              DeviceType: deviceType,
              EmailID: contract.userData.EmailID,
            })
          )}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
      );

      if (response.data?.result === 1) {
        onClose();
        setTimeout(() => {
          toast.success("Submitted successfully"); 
        }, 200); // A slight delay to allow modal unmounting

       
      } else {
        setTestResultError(t('failedsavehba1c'));
      }
    } catch (err) {
      setTestResultError(t('errorinhba1c'));
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const handleCancel = () => {
    // resetFields();
    onClose();
  };

  // Function to handle numeric input
  // const handleNumericInput = (e) => {
  //   const value = e.target.value.replace(/[^0-9.]/g, ""); // Allow only numbers and dot
  //   setTestResult(value);
  // };
   // Updated: Clear validation message dynamically for test result
   const handleNumericInput = (e) => {
    const value = e.target.value.replace(/[^0-9.]/g, "");
    setTestResult(value);
    if (value.trim()) {
      setTestResultError("");
    }
  };

  // Updated: Clear validation message dynamically for test date
  const handleDateChange = (date) => {
    setTestDate(date);
    if (date) {
      setTestDateError("");
    }
  };

  return (
    <>
    
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Vitals Entry"
      className="tracker-modal-content"
      overlayClassName="tracker-modal-overlay"
      shouldCloseOnOverlayClick={false}
    >
      <h2>{t('hbheading1')}</h2>
      <p>{t('hbheading2')}</p>
      <p>
       {t('hbheading3')} 
        {t('hbheading4')}
        <strong>{t('winsupport')}</strong> {t('meaning')}
      </p> 
      <p>&nbsp;</p>
      <div className="model-form-wrapper">
        <div className="mb-4 row align-items-center">
          <label htmlFor="email" className="col-sm-4 model-form-label">{t('hba1ctest')}</label>
          <div className="col-sm-8">
          <input
              type="text"
              id="testResult"
              value={testResult}
              onChange={handleNumericInput}
              className="form-control win-form-control mobile-view"
              placeholder={t('hba1ctest')}
              maxLength={10} // Limit HbA1c values to 5 characters (e.g., "12.3")
              inputMode="decimal" // Ensures numeric keyboard on mobile
              pattern="\d*" // Restricts non-numeric input
              required
            />   
             {testResultError && (
              <div className="form-field-error-message">{testResultError}</div>
            )} 
          </div>
        </div>
        
          <div className="mb-4 row align-items-center">
            <label htmlFor="email" className="col-sm-4 model-form-label">{t('daytest')}</label>
            <div className="col-sm-8 redem-rewards">
            <DatePicker
              selected={testDate}
              onChange={handleDateChange}
              dateFormat="MM/dd/yyyy"
              placeholderText="MM/DD/YYYY"
              className="form-control win-form-control  calendar-control"
              onKeyDown={(e) => e.preventDefault()}
              popperPlacement="bottom-start"
              showYearDropdown
              scrollableYearDropdown
            />
{testDateError && (
              <div className="form-field-error-message">{testDateError}</div>
            )}
            </div>
          </div>
          <div className="mb-4 row align-items-center">
            <label className="col-sm-4 model-form-label"></label>
            <div className="col-sm-8">
              <button
                className="win-btn-secondary model-popup-btn me-3 mb-3 mb-sm-0"
                onClick={handleCancel}
              >
                {t('Cancel')}
              </button>
              <button
              type="submit"
              onClick={handleSaveHbA1cDetails}
              disabled={loading}
              className="win-btn-primary model-popup-btn "
            >
              {loading ? "Saving..." : "Submit"}
            </button>
            </div>
          </div>
        </div>
    </Modal>
    <ToastContainer />
    </>
  );
};

export default WINHbA1cModal;
